export default __webpack_public_path__ + "assets/folder-open-18a8096.svg";